export default {
  // namespaced:true,
  state: {
    price_range_modall:false,  //价格分别图模态框是否显示

  },
  mutations: {
    set_price_range_modall(state, price_range_modall) {
      if(JSON.stringify(state.price_range_modall) !== JSON.stringify(price_range_modall)){
        state.price_range_modall = JSON.parse(JSON.stringify(price_range_modall))
      }
    },
  },
  getters: {
    get_price_range_modall:state =>state.price_range_modall,

  },
  actions: {
    other_logOut({ state, commit }){
      commit('set_price_range_modall',false);
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/module/other.js